if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const self = this;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else{
              // Enavi custom events to add addons to the cart
              document.addEventListener('enavi:cart:form-item:added', function (e) {
                const addonsAdded = e.detail
                if (!self.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }
                if (!self.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
                self.error = false;
                const quickAddModal = self.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        self.cart.renderContents(response);
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  //If Addons were added to the cart, get cart contents and render
                  if(addonsAdded){
                    fetch(`${routes.cart_url}?sections=${self.cart.getSectionsToRender().map(section => section.id)}`).then((response) => response.json()).then((response) => {

                      for (const key in response) {
                        if (response.hasOwnProperty(key)) {
                          if( document.querySelector(key)){
                            const newElement = new DOMParser().parseFromString(response[key], 'text/html').querySelector('#CartDrawer').innerHTML;
                            document.querySelector('#CartDrawer').innerHTML  = newElement;
                          }

                          if(key == 'cart-icon-bubble') document.querySelector(`#${key}`).innerHTML  = new DOMParser().parseFromString(response[key], 'text/html').querySelector('#shopify-section-cart-icon-bubble').innerHTML;
                        }
                      }
                      setTimeout(() => {
                        self.cart.open();
                      });
                    })

                  }else{
                    self.cart.renderContents(response);
                  }
                }
              }, { once: true });
              //Add addons if exist
              document.dispatchEvent(new CustomEvent('enavi:addAddonsToCart'));
            } 
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

/*======================
    Enavi Custom JS
=======================*/

window.theme = window.theme || {};

theme.EnaviProductForm =(function(){
  
  function EnaviProductForm(container){
    if(container){
      this.init(container);
    }
  };

  EnaviProductForm.prototype = Object.assign({}, EnaviProductForm.prototype, {
    init: function(container){
      this.container = container;
      this.sectionID = this.container.dataset.section;
      this.form      = this.container.querySelector('#product-form-'+this.sectionID);
      this.addToCart = this.container.querySelector('#ProductSubmitButton-'+this.sectionID);
      this.variantSelectorEl = this.container.querySelector('variant-selects');
      this.mediaGallery = document.querySelector('product-modal');
      this.addToCart.type="button";
      this.allItems = [];
      if(this.form){
        this.addToCart.addEventListener('click', this.handleAtc.bind(this));
      }
      document.addEventListener('enavi:addAddonsToCart', this.addAlltemsToCart.bind(this));
      document.addEventListener('enavi:product-image:change', this.changeImageOnAddOnSelect.bind(this));
      this.selectAll('.enavi_addon').forEach(node => {
        node.addEventListener('change', this.changeImageOnAddOnSelect.bind(this))
      });
      this.initCheckCompatibility();
    },

    select: function(selector){
      return this.container.querySelector(selector);
    },

    selectAll: function(selector){
      return Array.prototype.slice.apply(this.container.querySelectorAll(selector));
    },

    handleAtc: function(){
      if(this.postDisabled){
        return;
      }
      this.postDisabled = true;
      this.prepareAndPostFormData();
    },

    prepareAndPostFormData: function(){
        this.allItems = this.getAllItems();
        
        if(!this.checkIfRequiredOptionsFilled(this.allItems)){
          this.postDisabled = false;
          return;
        }

        this.emitSubmitEvent();
    },

    getAllItems: function(){
      this.generateParentRefKey();

      const addonLineProps = this.selectAll('.addon-line-item-prop');

      addonLineProps.forEach(el => {
        el.remove();
      });

      const addonItems = this.getAddonItems();

      if(addonItems.length > 0){
        this.addParentLineItemProperties(addonItems);
      }
      return addonItems;
    },

    emitSubmitEvent: function(){     
      setTimeout((function(){
        this.addToCart.disabled = false;
        this.addToCart.setAttribute('type','submit');
        this.addToCart.click();
        this.addToCart.setAttribute('type','button');
        this.addToCart.classList.remove('btn--loading');
      }).bind(this),100);
    },
    
    addAlltemsToCart: function(){
      if (this.allItems.length === 0){
        document.dispatchEvent(new CustomEvent('enavi:cart:form-item:added'));
        this.postDisabled = false;
        return;
      }

      const data = { items: this.allItems };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((response) => {
          document.dispatchEvent(new CustomEvent('enavi:cart:form-item:added', { detail: response }));
          this.postDisabled = false;
        })
        .catch((error) => {
          console.error('Error occurred during the request:', error);
       });

      this.allItems = [];
    },

    generateParentRefKey: function () {
      var count = 2;
      var key='';
      while(count > 0){
        key = key + (Math.random() + 1).toString(36).substring(2);
        count--;
      }
      this.parentKey = key;
    },

    addParentLineItemProperties: function(addonItems){
      var lineItemProps = { _parent_product: true };
      addonItems.forEach(item => { 
        lineItemProps[item.title] = item.price;
        if (item.parentLineItem == "true"){
          Object.entries(item.properties).map((function(property){
            if (!property[0].startsWith('_')){
              lineItemProps[property[0]] = property[1];
              delete item.properties[property[0]];
            }
          }))   
        }
      });

      for( let propName in lineItemProps){
        const propNode = this.select('[name="properties['+propName+']"]');
        if(propNode){
          propNode.value = lineItemProps[propName]; 
        }else{
          const newInput = document.createElement('input');
          newInput.type = 'hidden';
          newInput.className = 'addon-line-item-prop';
          newInput.name = 'properties[' + propName + ']';
          newInput.value = lineItemProps[propName];
          this.form.appendChild(newInput);
        }
      }
    },

    getAddonItems: function() {
      var addonItems = Array.prototype.slice.call(this.container.querySelectorAll('.enavi_addon:checked')).map((function(item){

        var qtySelector = this.select('.quantity__input');
        var qty = 1;
        if (qtySelector){
          var qty = this.select('.quantity__input').value;
        }

        var addonItemData =  { 
          id: item.value, 
          quantity: qty,
          title: item.dataset.addonTitle,
          price: item.dataset.addonPrice,
          properties: {
            _child_product: true
          }
        };
        
        addonItemData.properties = Object.assign({}, addonItemData.properties,  this.getAddonLineItemProperties(item));

        if (item.hasAttribute('data-parent-line')){
          addonItemData.parentLineItem = 'true';
        };
        return addonItemData;
      }).bind(this));

      return addonItems;
    },

    getAddonLineItemProperties: function (item) {
      var properties = {};
      this.selectAll('.addon_property[data-variant-id="'+item.value +'"]').forEach(function (propertyNode) {
          if((propertyNode.type === "text" && propertyNode.value) || propertyNode.checked === true){
            properties[propertyNode.name] = propertyNode.value.replace(/"/g, '&quot;');
          }
      });
      return properties;
    },

    changeImageOnAddOnSelect: function(event) {
      console.log('triggering changeImageOnAddOnSelect')
      if (!this.variantSelectorEl) {
        return
      }
      var variant = event.detail?.variant;
      if(!variant){
        variant = this.variantSelectorEl.getCurrentVariant();
      }
      
      var targetVariantImageAltText = variant.option1 + '+' + variant.option2; 

      const bolt = this.select('#bolt-container input.enavi_addon:checked');
      if(bolt){
        targetVariantImageAltText = targetVariantImageAltText + '+Bolt';
        if (bolt.hasAttribute('data-addon-variant-title')) {
          if(this.select("[alt='"+targetVariantImageAltText+':'+bolt.getAttribute('data-addon-variant-title')+"']")){
            targetVariantImageAltText = targetVariantImageAltText + ':'+ bolt.getAttribute('data-addon-variant-title');
          }
        }  
      }

      if (event.target.tagName === 'INPUT' && event.target.hasAttribute('data-bolt-clip')) {
        const mainContainerForInput = event.target.closest('[data-main-container]')
        const noteContainer = mainContainerForInput?.querySelector('[data-note-container]');
        if (noteContainer) {
          noteContainer.classList.toggle('hidden', !event.target.checked)
        }
      }

      const clip = this.select('#clip-container input.enavi_addon:checked');
      if(clip){
        targetVariantImageAltText = targetVariantImageAltText + '+Clip';
        if (clip.hasAttribute('data-addon-variant-title')) {
          if(this.select("[alt='"+targetVariantImageAltText+':'+clip.getAttribute('data-addon-variant-title')+"']")){
            targetVariantImageAltText = targetVariantImageAltText + ':'+ clip.getAttribute('data-addon-variant-title');
          }
        }
      }

      var copiedVariant = JSON.parse(JSON.stringify(variant));

      if(bolt || clip){
        var selectedImage = this.mediaGallery.querySelector("[alt='"+targetVariantImageAltText+"']");
        if(selectedImage){
          copiedVariant.featured_media.id = parseInt(selectedImage.dataset.mediaId);
        }
      }

      const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.variantSelectorEl.dataset.section}"]`);
      mediaGalleries.forEach((mediaGallery) =>
        mediaGallery.setActiveMedia(`${this.variantSelectorEl.dataset.section}-${copiedVariant.featured_media.id}`, true)
      );
  
      const modalContent = document.querySelector(`#ProductModal-${this.variantSelectorEl.dataset.section} .product-media-modal__content`);
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector(`[data-media-id="${copiedVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
      
    },

    checkIfRequiredOptionsFilled: function(allItems){
      emptyRequiredOptions  = [];
      allItems.forEach(item => {
        emptyRequiredOptions = emptyRequiredOptions.concat(this.selectAll('.option_required[type="text"][data-variant-id="'+item.id +'"]').filter(optionNode => {
          if(!optionNode.value || !optionNode.value.trim()){
            optionNode.closest('.enavi_option').classList.add('enavi_option_error');
            return true;
          }
          optionNode.closest('.enavi_option').classList.remove('enavi_option_error');
          return false;
          
        }));        
      });
      return !emptyRequiredOptions.length; 
    },

    initCheckCompatibility: function() {
      document.querySelector('#enavi-check_compatibility')?.addEventListener("click", function(event) {
        event.preventDefault();
        const shogunTabs = [...document.querySelectorAll('span.shogun-tab-title')];
        const inkRefillTab = shogunTabs.find(span => span.innerText.toLowerCase() === 'ink refills');
        inkRefillTab?.click();
        inkRefillTab?.scrollIntoView({behavior: "smooth"})
      });
    }

  });

  return EnaviProductForm;
})();

new theme.EnaviProductForm(document.querySelector('product-info'));